/* eslint-disable no-unused-vars */
import React, { useState, memo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { SET_SELECTED_FILTER } from 'estimate_list/reducers/initial'
import { filterTheorem } from 'estimate_list/libs/util'
import FilterColumn from './filter_column'

const FilterBrand = ({ makerList }) => {
    const selectedFilters = useSelector(state => state.initial.selectedFilters)
    const [sort, setSort] = useState(0) // 0: 상품수순 1: 가나다순

    const dispatch = useDispatch()

    const topDataArr = () => {
        const arr = makerList.filter((v, i) => 
            v.maker_rec === 1 && makerList.findIndex(m => m.maker_name === v.maker_name) === i
        );
        return arr;
    }

    const topData = topDataArr()
    const onClickBrand = (maker_id, maker_name) => () => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'brand',
                value: { maker_id, maker_name }
            })
        })
    }

    const active = maker_id => {
        const index = selectedFilters.maker.findIndex(v => v.maker_id === maker_id)
        return index > -1
    }

    const onClickSort = data => () => {
        setSort(data)
    }

    const sortList = () => {
        // 같은 제조사 중 가장 높은 item_cnt를 가진 항목만 필터링
        const uniqueMakers = [...makerList].reduce((acc, current) => {
            const existingMaker = acc.find(item => item.maker_name === current.maker_name);
            if (!existingMaker) {
                return [...acc, current];
            } else if (current.item_cnt > existingMaker.item_cnt) {
                // 기존 항목을 제거하고 더 높은 item_cnt를 가진 현재 항목으로 교체
                return [...acc.filter(item => item.maker_name !== current.maker_name), current];
            }
            return acc;
        }, []);

        // 정렬 수행
        if (sort === 0) {
            uniqueMakers.sort((a, b) => (
                a.item_cnt > b.item_cnt ? -1 : 1
            ));
        } else if (sort === 1) {
            uniqueMakers.sort((a, b) => (
                a.maker_name < b.maker_name ? -1 : 1
            ));
        }
        return uniqueMakers;
    }

    return (
        <FilterColumn title="제조사">
            <div className="row">
                {topData.length > 0 && (
                    <ul className="title_list">
                        {topData.map(v => (
                            <li className={`${active(v.maker_id) ? 'active' : ''}`} key={v.maker_id}>
                                <button type="button" onClick={onClickBrand(v.maker_id, v.maker_name)}>
                                    <span className="text">{v.maker_name}</span>
                                    <i className="icon-close" />
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
                <div className="title_sort">
                    <button type="button" className={`sort_btn ${sort === 0 ? 'active' : ''}`} onClick={onClickSort(0)}>
                        <i className="icon-check1" />
                        상품수순
                    </button>
                    <button type="button" className={`sort_btn ${sort === 1 ? 'active' : ''}`} onClick={onClickSort(1)}>
                        <i className="icon-check1" />
                        가나다순
                    </button>
                </div>
                <div className="cell">
                    <ul className="list">
                        {sortList().map(v => (
                            <li className={`${active(v.maker_id) ? 'active' : ''}`} key={v.maker_id}>
                                <button type="button" onClick={onClickBrand(v.maker_id, v.maker_name)}>
                                    <span className="text">{v.maker_name}</span>
                                    <i className="icon-close" />
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </FilterColumn>
    )
}

export default memo(FilterBrand)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_brand.js